import { createTheme, responsiveFontSizes } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#1782FF",
    },
    secondary: {
      main: "#757575",
    },
    success: {
      main: "#1b5e20",
    },
    error: {
      main: "#b71c1c",
    },
    warning: {
      main: "#ff6f00",
    },
  },
  typography: {
    fontFamily: ["Rubik"].join(","),

    h1: {
      fontFamily: ["Rubik"].join(","),
      fontWeight: 600,
    },
    h2: {
      fontFamily: ["Rubik"].join(","),
      fontWeight: 600,
    },
    h3: {
      fontFamily: ["Rubik"].join(","),
      fontWeight: 600,
    },
    h4: {
      fontFamily: ["Rubik"].join(","),
      fontWeight: 600,
    },
    h5: {
      fontFamily: ["Rubik"].join(","),
      fontWeight: 400,
    },
    h6: {
      fontFamily: ["Rubik"].join(","),
      fontSize: "14px",
    },
    caption: {
      fontFamily: ["Rubik"].join(","),
      fontWeight: 400,
      color: "#808080",
    },
  },
});
export default responsiveFontSizes(theme);
